import { AnimatedSprite, Application, Assets, Sprite, Spritesheet, SpritesheetData, Texture } from "pixi.js"
import { TILE_SIZE, PLAYER_HEIGHT, PLAYER_WIDTH, SCALE_FACTOR, CHAR_WIDTH, CHAR_HEIGHT } from "./config"

export const atlasData = {
  frames: {
    undestroyableWall: { frame: { x: 409, y: 48, w: TILE_SIZE, h: TILE_SIZE } },
    plainGrass: { frame: { x: 441, y: 48, w: TILE_SIZE, h: TILE_SIZE } },
    shadowedPlainGrass: { frame: { x: 441 + TILE_SIZE, y: 48, w: TILE_SIZE, h: TILE_SIZE } },

    wall: { frame: { x: 505, y: 78, w: TILE_SIZE, h: TILE_SIZE } },
    wallExplosion1: { frame: { x: 505 + TILE_SIZE * 1, y: 78, w: TILE_SIZE, h: TILE_SIZE } },
    wallExplosion2: { frame: { x: 505 + TILE_SIZE * 2, y: 78, w: TILE_SIZE, h: TILE_SIZE } },
    wallExplosion3: { frame: { x: 505 + TILE_SIZE * 3, y: 78, w: TILE_SIZE, h: TILE_SIZE } },
    wallExplosion4: { frame: { x: 505 + TILE_SIZE * 4, y: 78, w: TILE_SIZE, h: TILE_SIZE } },
    wallExplosion5: { frame: { x: 505 + TILE_SIZE * 5, y: 78, w: TILE_SIZE, h: TILE_SIZE } },
    wallExplosion6: { frame: { x: 505 + TILE_SIZE * 6, y: 78, w: TILE_SIZE, h: TILE_SIZE } },

    powerUpExplosion1: { frame: { x: 505, y: 94, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpExplosion2: { frame: { x: 505 + TILE_SIZE * 1, y: 94, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpExplosion3: { frame: { x: 505 + TILE_SIZE * 2, y: 94, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpExplosion4: { frame: { x: 505 + TILE_SIZE * 3, y: 94, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpExplosion5: { frame: { x: 505 + TILE_SIZE * 4, y: 94, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpExplosion6: { frame: { x: 505 + TILE_SIZE * 5, y: 94, w: TILE_SIZE, h: TILE_SIZE } },

    powerUpBomb1: { frame: { x: 409, y: 64, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpBomb2: { frame: { x: 409, y: 80, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpSkates1: { frame: { x: 409 + TILE_SIZE * 1, y: 64, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpSkates2: { frame: { x: 409 + TILE_SIZE * 1, y: 80, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpKick1: { frame: { x: 409 + TILE_SIZE * 2, y: 64, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpKick2: { frame: { x: 409 + TILE_SIZE * 2, y: 80, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpPunch1: { frame: { x: 409 + TILE_SIZE * 3, y: 64, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpPunch2: { frame: { x: 409 + TILE_SIZE * 3, y: 80, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpFire1: { frame: { x: 409 + TILE_SIZE * 4, y: 64, w: TILE_SIZE, h: TILE_SIZE } },
    powerUpFire2: { frame: { x: 409 + TILE_SIZE * 4, y: 80, w: TILE_SIZE, h: TILE_SIZE } },
    poison1: { frame: { x: 409 + TILE_SIZE * 5, y: 64, w: TILE_SIZE, h: TILE_SIZE } },
    poison2: { frame: { x: 409 + TILE_SIZE * 5, y: 80, w: TILE_SIZE, h: TILE_SIZE } },

    char0: { frame: { x: 505, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char1: { frame: { x: 505 + 8 * 1, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char2: { frame: { x: 505 + 8 * 2, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char3: { frame: { x: 505 + 8 * 3, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char4: { frame: { x: 505 + 8 * 4, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char5: { frame: { x: 505 + 8 * 5, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char6: { frame: { x: 505 + 8 * 6, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char7: { frame: { x: 505 + 8 * 7, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char8: { frame: { x: 505 + 8 * 8, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    char9: { frame: { x: 505 + 8 * 9, y: 64, w: CHAR_WIDTH, h: CHAR_HEIGHT } },
    "char:": { frame: { x: 505 + 8 * 10, y: 64, w: 8, h: 14 } },

    fireEndLeft1: { frame: { x: 409, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndLeft2: { frame: { x: 409 + TILE_SIZE * 1, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndLeft3: { frame: { x: 409 + TILE_SIZE * 2, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndLeft4: { frame: { x: 409 + TILE_SIZE * 3, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndLeft5: { frame: { x: 409 + TILE_SIZE * 4, y: 0, w: TILE_SIZE, h: TILE_SIZE } },

    fireEndRight1: { frame: { x: 409, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndRight2: { frame: { x: 409 + TILE_SIZE * 1, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndRight3: { frame: { x: 409 + TILE_SIZE * 2, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndRight4: { frame: { x: 409 + TILE_SIZE * 3, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndRight5: { frame: { x: 409 + TILE_SIZE * 4, y: 16, w: TILE_SIZE, h: TILE_SIZE } },

    fireEndBottom1: { frame: { x: 409, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndBottom2: { frame: { x: 409 + TILE_SIZE * 1, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndBottom3: { frame: { x: 409 + TILE_SIZE * 2, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndBottom4: { frame: { x: 409 + TILE_SIZE * 3, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndBottom5: { frame: { x: 409 + TILE_SIZE * 4, y: 32, w: TILE_SIZE, h: TILE_SIZE } },

    fireEndTop1: { frame: { x: 489, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndTop2: { frame: { x: 489 + TILE_SIZE * 1, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndTop3: { frame: { x: 489 + TILE_SIZE * 2, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndTop4: { frame: { x: 489 + TILE_SIZE * 3, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    fireEndTop5: { frame: { x: 489 + TILE_SIZE * 4, y: 0, w: TILE_SIZE, h: TILE_SIZE } },

    fireMiddleHorizontal1: { frame: { x: 489, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleHorizontal2: { frame: { x: 489 + TILE_SIZE * 1, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleHorizontal3: { frame: { x: 489 + TILE_SIZE * 2, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleHorizontal4: { frame: { x: 489 + TILE_SIZE * 3, y: 16, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleHorizontal5: { frame: { x: 489 + TILE_SIZE * 4, y: 16, w: TILE_SIZE, h: TILE_SIZE } },

    fireMiddleVertical1: { frame: { x: 489, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleVertical2: { frame: { x: 489 + TILE_SIZE * 1, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleVertical3: { frame: { x: 489 + TILE_SIZE * 2, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleVertical4: { frame: { x: 489 + TILE_SIZE * 3, y: 32, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleVertical5: { frame: { x: 489 + TILE_SIZE * 4, y: 32, w: TILE_SIZE, h: TILE_SIZE } },

    fireMiddleCross1: { frame: { x: 489, y: 48, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleCross2: { frame: { x: 489 + TILE_SIZE * 1, y: 48, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleCross3: { frame: { x: 489 + TILE_SIZE * 2, y: 48, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleCross4: { frame: { x: 489 + TILE_SIZE * 3, y: 48, w: TILE_SIZE, h: TILE_SIZE } },
    fireMiddleCross5: { frame: { x: 489 + TILE_SIZE * 4, y: 48, w: TILE_SIZE, h: TILE_SIZE } },

    bomb1: { frame: { x: 569, y: 0, w: TILE_SIZE, h: 17 } },
    bomb2: { frame: { x: 569 + TILE_SIZE * 1, y: 0, w: TILE_SIZE, h: 17 } },
    bomb3: { frame: { x: 569 + TILE_SIZE * 2, y: 0, w: TILE_SIZE, h: 17 } },

    player1StatusActive: { frame: { x: 1, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    player1StatusDead: { frame: { x: 1 + 1 * TILE_SIZE, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    player1StatusInactive: { frame: { x: 1 + 2 * TILE_SIZE, y: 0, w: TILE_SIZE, h: TILE_SIZE } },
    player2StatusActive: { frame: { x: 1, y: 1 + 1 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player2StatusDead: { frame: { x: 1 + 1 * TILE_SIZE, y: 1 + 1 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player2StatusInactive: { frame: { x: 1 + 2 * TILE_SIZE, y: 1 + 1 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player3StatusActive: { frame: { x: 1, y: 1 + 2 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player3StatusDead: { frame: { x: 1 + 1 * TILE_SIZE, y: 1 + 2 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player3StatusInactive: { frame: { x: 1 + 2 * TILE_SIZE, y: 1 + 2 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player4StatusActive: { frame: { x: 1, y: 1 + 3 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player4StatusDead: { frame: { x: 1 + 1 * TILE_SIZE, y: 1 + 3 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },
    player4StatusInactive: { frame: { x: 1 + 2 * TILE_SIZE, y: 1 + 3 * (11 + TILE_SIZE), w: TILE_SIZE, h: TILE_SIZE } },

    player1WalkDown1: { frame: { x: 50, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkDown2: { frame: { x: 50 + 18 * 1, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkDown3: { frame: { x: 50 + 18 * 2, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkLeft1: { frame: { x: 50 + 18 * 3, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkLeft2: { frame: { x: 50 + 18 * 4, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkLeft3: { frame: { x: 50 + 18 * 5, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkRight1: { frame: { x: 50 + 18 * 6, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkRight2: { frame: { x: 50 + 18 * 7, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkRight3: { frame: { x: 50 + 18 * 8, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkUp1: { frame: { x: 50 + 18 * 9, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkUp2: { frame: { x: 50 + 18 * 10, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1WalkUp3: { frame: { x: 50 + 18 * 11, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    plauer1PunchDown: { frame: { x: 50 + 18 * 12, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1PunchLeft: { frame: { x: 50 + 18 * 13, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1PunchRight: { frame: { x: 50 + 18 * 14, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1PunchUp: { frame: { x: 50 + 18 * 15, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1Die1: { frame: { x: 50 + 18 * 16, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1Die2: { frame: { x: 50 + 18 * 17, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1Die3: { frame: { x: 50 + 18 * 18, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player1Die4: { frame: { x: 50 + 18 * 19, y: 0, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },

    player2WalkDown1: { frame: { x: 50, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkDown2: { frame: { x: 50 + 18 * 1, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkDown3: { frame: { x: 50 + 18 * 2, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkLeft1: { frame: { x: 50 + 18 * 3, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkLeft2: { frame: { x: 50 + 18 * 4, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkLeft3: { frame: { x: 50 + 18 * 5, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkRight1: { frame: { x: 50 + 18 * 6, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkRight2: { frame: { x: 50 + 18 * 7, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkRight3: { frame: { x: 50 + 18 * 8, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkUp1: { frame: { x: 50 + 18 * 9, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkUp2: { frame: { x: 50 + 18 * 10, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2WalkUp3: { frame: { x: 50 + 18 * 11, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2PunchDown: { frame: { x: 50 + 18 * 12, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2PunchLeft: { frame: { x: 50 + 18 * 13, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2PunchRight: { frame: { x: 50 + 18 * 14, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2PunchUp: { frame: { x: 50 + 18 * 15, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2Die1: { frame: { x: 50 + 18 * 16, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2Die2: { frame: { x: 50 + 18 * 17, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2Die3: { frame: { x: 50 + 18 * 18, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player2Die4: { frame: { x: 50 + 18 * 19, y: 28, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },

    player3WalkDown1: { frame: { x: 50, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkDown2: { frame: { x: 50 + 18 * 1, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkDown3: { frame: { x: 50 + 18 * 2, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkLeft1: { frame: { x: 50 + 18 * 3, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkLeft2: { frame: { x: 50 + 18 * 4, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkLeft3: { frame: { x: 50 + 18 * 5, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkRight1: { frame: { x: 50 + 18 * 6, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkRight2: { frame: { x: 50 + 18 * 7, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkRight3: { frame: { x: 50 + 18 * 8, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkUp1: { frame: { x: 50 + 18 * 9, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkUp2: { frame: { x: 50 + 18 * 10, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3WalkUp3: { frame: { x: 50 + 18 * 11, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3PunchDown: { frame: { x: 50 + 18 * 12, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3PunchLeft: { frame: { x: 50 + 18 * 13, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3PunchRight: { frame: { x: 50 + 18 * 14, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3PunchUp: { frame: { x: 50 + 18 * 15, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3Die1: { frame: { x: 50 + 18 * 16, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3Die2: { frame: { x: 50 + 18 * 17, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3Die3: { frame: { x: 50 + 18 * 18, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player3Die4: { frame: { x: 50 + 18 * 19, y: 54, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },

    player4WalkDown1: { frame: { x: 50, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkDown2: { frame: { x: 50 + 18 * 1, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkDown3: { frame: { x: 50 + 18 * 2, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkLeft1: { frame: { x: 50 + 18 * 3, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkLeft2: { frame: { x: 50 + 18 * 4, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkLeft3: { frame: { x: 50 + 18 * 5, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkRight1: { frame: { x: 50 + 18 * 6, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkRight2: { frame: { x: 50 + 18 * 7, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkRight3: { frame: { x: 50 + 18 * 8, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkUp1: { frame: { x: 50 + 18 * 9, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkUp2: { frame: { x: 50 + 18 * 10, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4WalkUp3: { frame: { x: 50 + 18 * 11, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4PunchDown: { frame: { x: 50 + 18 * 12, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4PunchLeft: { frame: { x: 50 + 18 * 13, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4PunchRight: { frame: { x: 50 + 18 * 14, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4PunchUp: { frame: { x: 50 + 18 * 15, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4Die1: { frame: { x: 50 + 18 * 16, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4Die2: { frame: { x: 50 + 18 * 17, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4Die3: { frame: { x: 50 + 18 * 18, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
    player4Die4: { frame: { x: 50 + 18 * 19, y: 81, w: PLAYER_WIDTH, h: PLAYER_HEIGHT } },
  },
  meta: {
    scale: 2
  },
  animations: {
    startBlock: [
      "undestroyableWall",
      "powerUpExplosion1",
      "powerUpExplosion2",
      "powerUpExplosion3",
      "powerUpExplosion4",
      "powerUpExplosion5",
      "powerUpExplosion6"
    ],
    undestroyableWall: [
      "undestroyableWall"
    ],
    wall: [
      "wall",
      "wallExplosion1",
      "wallExplosion2",
      "wallExplosion3",
      "wallExplosion4",
      "wallExplosion5",
      "wallExplosion6"
    ],
    fireEndLeft: [
      "fireEndLeft1",
      "fireEndLeft2",
      "fireEndLeft3",
      "fireEndLeft4",
      "fireEndLeft5"
    ],
    fireEndRight: [
      "fireEndRight1",
      "fireEndRight2",
      "fireEndRight3",
      "fireEndRight4",
      "fireEndRight5"
    ],
    fireEndBottom: [
      "fireEndBottom1",
      "fireEndBottom2",
      "fireEndBottom3",
      "fireEndBottom4",
      "fireEndBottom5"
    ],
    fireEndTop: [
      "fireEndTop1",
      "fireEndTop2",
      "fireEndTop3",
      "fireEndTop4",
      "fireEndTop5"
    ],
    fireMiddleHorizontal: [
      "fireMiddleHorizontal1",
      "fireMiddleHorizontal2",
      "fireMiddleHorizontal3",
      "fireMiddleHorizontal4",
      "fireMiddleHorizontal5"
    ],
    fireMiddleVertical: [
      "fireMiddleVertical1",
      "fireMiddleVertical2",
      "fireMiddleVertical3",
      "fireMiddleVertical4",
      "fireMiddleVertical5"
    ],
    fireMiddleCross: [
      "fireMiddleCross1",
      "fireMiddleCross2",
      "fireMiddleCross3",
      "fireMiddleCross4",
      "fireMiddleCross5"
    ],
    bomb: [
      "bomb1",
      "bomb2",
      "bomb3",
      "bomb2",
    ],

    powerUpBomb: [
      "powerUpBomb1",
      "powerUpBomb2",
    ],
    powerUpSkates: [
      "powerUpSkates1",
      "powerUpSkates2",
    ],
    powerUpKick: [
      "powerUpKick1",
      "powerUpKick2",
    ],
    powerUpPunch: [
      "powerUpPunch1",
      "powerUpPunch2",
    ],
    powerUpFire: [
      "powerUpFire1",
      "powerUpFire2",
    ],
    poison: [
      "poison1",
      "poison2",
    ],

    powerUpExplosion: [
      "powerUpExplosion1",
      "powerUpExplosion2",
      "powerUpExplosion3",
      "powerUpExplosion4",
      "powerUpExplosion5",
      "powerUpExplosion6"
    ],

    player1WalkDown: [
      "player1WalkDown1",
      "player1WalkDown2",
      "player1WalkDown3",
      "player1WalkDown2",
    ],
    player1WalkLeft: [
      "player1WalkLeft1",
      "player1WalkLeft2",
      "player1WalkLeft3",
      "player1WalkLeft2",
    ],
    player1WalkRight: [
      "player1WalkRight1",
      "player1WalkRight2",
      "player1WalkRight3",
      "player1WalkRight2",
    ],
    player1WalkUp: [
      "player1WalkUp1",
      "player1WalkUp2",
      "player1WalkUp3",
      "player1WalkUp2",
    ],
    player1PunchDown: [
      "player1WalkDown2",
      "plauer1PunchDown"
    ],
    player1PunchLeft: [
      "player1WalkLeft2",
      "player1PunchLeft"
    ],
    player1PunchRight: [
      "player1WalkRight2",
      "player1PunchRight"
    ],
    player1PunchUp: [
      "player1WalkUp2",
      "player1PunchUp"
    ],
    player1Die: [
      "player1Die1",
      "player1Die2",
      "player1Die3",
      "player1Die3",
      "player1Die3",
      "player1Die4",
      "player1Die3",
      "player1Die4",
      "player1Die3",
      "player1Die4",
      "player1Die3",
      "player1Die4"
    ],
    player1Stunned: [
      "player1Die1",
      "player1Die2",
    ],
    player1Lying: [
      "player1Die3",
      "player1Die4",
    ],

    player2WalkDown: [
      "player2WalkDown1",
      "player2WalkDown2",
      "player2WalkDown3",
      "player2WalkDown2",
    ],
    player2WalkLeft: [
      "player2WalkLeft1",
      "player2WalkLeft2",
      "player2WalkLeft3",
      "player2WalkLeft2",
    ],
    player2WalkRight: [
      "player2WalkRight1",
      "player2WalkRight2",
      "player2WalkRight3",
      "player2WalkRight2",
    ],
    player2WalkUp: [
      "player2WalkUp1",
      "player2WalkUp2",
      "player2WalkUp3",
      "player2WalkUp2",
    ],
    player2PunchDown: [
      "player2WalkDown2",
      "player2PunchDown"
    ],
    player2PunchLeft: [
      "player2WalkLeft2",
      "player2PunchLeft"
    ],
    player2PunchRight: [
      "player2WalkRight2",
      "player2PunchRight"
    ],
    player2PunchUp: [
      "player2WalkUp2",
      "player2PunchUp"
    ],
    player2Die: [
      "player2Die1",
      "player2Die2",
      "player2Die3",
      "player2Die3",
      "player2Die3",
      "player2Die4",
      "player2Die3",
      "player2Die4",
      "player2Die3",
      "player2Die4",
      "player2Die3",
      "player2Die4"
    ],
    player2Stunned: [
      "player2Die1",
      "player2Die2",
    ],
    player2Lying: [
      "player2Die3",
      "player2Die4",
    ],

    player3WalkDown: [
      "player3WalkDown1",
      "player3WalkDown2",
      "player3WalkDown3",
      "player3WalkDown2",
    ],
    player3WalkLeft: [
      "player3WalkLeft1",
      "player3WalkLeft2",
      "player3WalkLeft3",
      "player3WalkLeft2",
    ],
    player3WalkRight: [
      "player3WalkRight1",
      "player3WalkRight2",
      "player3WalkRight3",
      "player3WalkRight2",
    ],
    player3WalkUp: [
      "player3WalkUp1",
      "player3WalkUp2",
      "player3WalkUp3",
      "player3WalkUp2",
    ],
    player3PunchDown: [
      "player3WalkDown2",
      "player3PunchDown"
    ],
    player3PunchLeft: [
      "player3WalkLeft2",
      "player3PunchLeft"
    ],
    player3PunchRight: [
      "player3WalkRight2",
      "player3PunchRight"
    ],
    player3PunchUp: [
      "player3WalkUp2",
      "player3PunchUp"
    ],
    player3Die: [
      "player3Die1",
      "player3Die2",
      "player3Die3",
      "player3Die3",
      "player3Die3",
      "player3Die4",
      "player3Die3",
      "player3Die4",
      "player3Die3",
      "player3Die4",
      "player3Die3",
      "player3Die4"
    ],
    player3Stunned: [
      "player3Die1",
      "player3Die2",
    ],
    player3Lying: [
      "player3Die3",
      "player3Die4",
    ],

    player4WalkDown: [
      "player4WalkDown1",
      "player4WalkDown2",
      "player4WalkDown3",
      "player4WalkDown2",
    ],
    player4WalkLeft: [
      "player4WalkLeft1",
      "player4WalkLeft2",
      "player4WalkLeft3",
      "player4WalkLeft2",
    ],
    player4WalkRight: [
      "player4WalkRight1",
      "player4WalkRight2",
      "player4WalkRight3",
      "player4WalkRight2",
    ],
    player4WalkUp: [
      "player4WalkUp1",
      "player4WalkUp2",
      "player4WalkUp3",
      "player4WalkUp2",
    ],
    player4PunchDown: [
      "player4WalkDown2",
      "player4PunchDown"
    ],
    player4PunchLeft: [
      "player4WalkLeft2",
      "player4PunchLeft"
    ],
    player4PunchRight: [
      "player4WalkRight2",
      "player4PunchRight"
    ],
    player4PunchUp: [
      "player4WalkUp2",
      "player4PunchUp"
    ],
    player4Die: [
      "player4Die1",
      "player4Die2",
      "player4Die3",
      "player4Die3",
      "player4Die3",
      "player4Die4",
      "player4Die3",
      "player4Die4",
      "player4Die3",
      "player4Die4",
      "player4Die3",
      "player4Die4"
    ],
    player4Stunned: [
      "player4Die1",
      "player4Die2",
    ],
    player4Lying: [
      "player4Die3",
      "player4Die4",
    ]
  }

}

//mutilply all frames by the scale 4
Object.keys(atlasData.frames).forEach((frame) => {
  const frameData = atlasData.frames[frame as keyof typeof atlasData.frames]
  frameData.frame.x *= SCALE_FACTOR
  frameData.frame.y *= SCALE_FACTOR
  frameData.frame.w *= SCALE_FACTOR
  frameData.frame.h *= SCALE_FACTOR
})

let spritesheet: Spritesheet<SpritesheetData>
export const loadSpritesheet = async (tileset: string): Promise<Spritesheet<SpritesheetData>> => {
  const texture = await Assets.load(tileset)
  spritesheet = new Spritesheet(
    texture,
    atlasData
  )
  await spritesheet.parse()
  return spritesheet
}

export const getSpritesheet = (): Spritesheet<SpritesheetData> => {
  if (!spritesheet) throw new Error("Spritesheet not loaded")
  return spritesheet
}

export const debugTextures = (app: Application) => {
  let l = 0
  let i = 0
  Object.keys(atlasData.frames).forEach((frame) => {
    const sprite = new Sprite(spritesheet.textures[frame as keyof typeof atlasData.frames])
    sprite.x = 0 + i * 40
    sprite.y = 0 + l * 55
    app.stage.addChild(sprite)
    i++
    if (i % 15 === 0) {
      l++
      i = 0
    }
  })
}

export const getAnimation = (animation: keyof typeof atlasData.animations): Texture[] => {
  return spritesheet.animations[animation]
}

export const getTexture = (texture: keyof typeof atlasData.frames): Texture => {
  return spritesheet.textures[texture]
}

export const debugAnimations = (app: Application) => {
  let l = 0
  let i = 0
  Object.keys(spritesheet.animations).forEach((animation) => {
    const anim = new AnimatedSprite(spritesheet.animations[animation as keyof typeof spritesheet.animations])
    anim.animationSpeed = 0.1
    anim.play()
    anim.x = 0 + i * 40
    anim.y = 0 + l * 60
    app.stage.addChild(anim)
    i++
    if (i % 15 === 0) {
      l++
      i = 0
    }
  })
}
